import {RichTextField} from '@hconnect/common/components/formFields'
import {ControlledFormField} from '@hconnect/common/types'
import {Controller, FieldValues} from 'react-hook-form'

import {useFormInputLabelWithSuffix} from '../../../hooks'

type RichTextFormFieldProps<TField extends FieldValues> = ControlledFormField<TField> & {
  pressAndHoldRecordLabel?: string
}

export const RichTextFormField = <TField extends FieldValues>({
  label,
  name,
  control,
  disabled,
  readOnly,
  pressAndHoldRecordLabel,
  optional
}: RichTextFormFieldProps<TField>) => {
  const fieldDisabled = disabled || readOnly
  const inputLabel = useFormInputLabelWithSuffix({label, optional})
  return (
    <Controller
      name={name}
      disabled={fieldDisabled}
      control={control}
      render={({field, fieldState}) => (
        <RichTextField
          data-test-id={`rich-text-field-${name}`}
          onChange={field.onChange}
          disabled={fieldDisabled}
          current={field.value}
          label={inputLabel}
          errorCodeLabel={fieldState.error?.message}
          pressAndHoldRecordLabel={pressAndHoldRecordLabel}
        />
      )}
    />
  )
}
